<template>
  <div class="static right-0 bottom-0 left-0 bg-white">
    <template
      v-for="item in footerItems"
      :key="item.href"
    >
      <a
        class="w-full flex items-center p-4"
        :href="item.href"
      >
        <span class="sr-only">{{ item.label }}</span>
        <component
          :is="item.icon"
          class="w-7 h-7 stroke-1 text-gray-800 hover:text-gray-500"
        />
        <span class="pl-2 text-left font-semibold flex-grow text-base text-gray-700">
          {{ item.label }}
        </span>
      </a>
    </template>
  </div>
</template>
<script setup>

import { inject } from 'vue';

const trans = inject('translate');

const footerItems = [
  {
    label: trans.get('miliboo.footer.need_for_assistance'),
    icon: 'v-icon-faq',
    href: '/faq',
  },
  {
    label: trans.get('miliboo.header.quick_actions.user.account'),
    icon: 'v-icon-user',
    href: '/my-account',
  },
];
</script>
